<template>
  <el-container id="mainContainer">
    <el-aside id="mainAside">
      <main-left v-on:func="selectPage" :id="id"/>
    </el-aside>
    <div class="divider-vertical"></div>
    <el-container>
      <el-header id="mainHead">
        <main-head  v-on:func="selectPage"/>
      </el-header>
      <div direction="horizontal" class="divider-horizontal"></div>
      <el-main id="mainMain" >
        <keep-alive >
          <component :is="mainContentPageName" v-on:func="selectPage" :id="id" ref="childData"/>
        </keep-alive>
      </el-main>
      <div direction="horizontal" class="divider-horizontal"></div>
      <el-footer id="mainFooter">
        <main-foot/>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import MainLeft from './MainLeft'
import MainHead from './MainHead'
import MainFoot from './MainFoot'
import MainWorkspace from './MainWorkspace'
import MainPublicAPP from './MainPublicAPP'
import MainAPPCenter from './MainAPPCenter'
import MainUndefined from './MainUndefined'
import MainFirmware from './MainFile'
export default {
  name: 'Main',
  data () {
    return {
      mainContentPageName: 'MainPublicAPP',
      id: ''
    }
  },
  components: {
    MainLeft,
    MainHead,
    MainFoot,
    MainWorkspace,
    MainPublicAPP,
    MainAPPCenter,
    MainFirmware,
    MainUndefined
  },
  methods: {
    selectPageName (key) {
      // console.log('key-arg', key)
      switch (key) {
        case '1':
          this.mainContentPageName = 'MainPublicAPP'
          return
        case '2':
          this.mainContentPageName = 'MainWorkspace'
          return
        case '3':
          this.mainContentPageName = 'MainAPPCenter'
          this.$refs.childData.$forceUpdate()// 执行子组件里的doSth函数
          return
        case '4':
          this.mainContentPageName = 'MainFirmware'
          return
        case '5':
          this.mainContentPageName = 'MainUndefined'
          return
        default:
          this.mainContentPageName = 'MainWorkspace'
      }
    },
    selectPage (key) { // 在监听到noticeParent进行事件处理
      this.selectPageName(key)
      // console.log('getNotice:'.concat(params).concat('-').concat(this.mainContentPageName))
    }
  }
}
</script>
<style>
.divider-vertical{
    width:1px;
    height:100%;
    background: #DCDFE6;
    color: #DCDFE6;
  }
.divider-horizontal {
  width:100%;
  height:1px;
  background: #DCDFE6;
  color: #DCDFE6;
  }
  #mainContainer{
    width: 100%;
    height: 100%;
  }
  #mainHead{
    text-align: center;
    min-width: 800px;
  }
  #mainAside{
    width: 200px;
  }
  #mainMain{
    width: 100%;
    min-width: 800px;
    height: 100%;
  }
  #mainFooter{
    width: 100%;
    min-width: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Main.vue